// main.js就是皇上
// vue就相当于天道，是”奉天承运“的那个”天“
import Vue from 'vue';
// App是大内总管，皇上不直接和底下人说话，通过App来传话
import App from "./App.vue";
// 引入路由
import router from './router';
// 注册全局路由权限守卫
import "./permission";
// 引入store
import store from "./store";
// 引入ElementUI
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// 引入vant ui
import Vant from 'vant';
// 引入vant ui的css样式: 这里面已经做好了一定的normalize的初始化, 一般无需再引入额外的normalize文件
import 'vant/lib/index.css';
// 引入点击复制功能
import VueClipboard from 'vue-clipboard2';

import './registerServiceWorker'
// 最后还得“使用”vant，才能让vant生效
Vue.use(Vant).use(ElementUI).use(VueClipboard);

Vue.config.productTip = false;

new Vue({
  router, //挂载路由
  store, // 挂载全局仓库store
  render: (h) => h(App),
}).$mount("#app");

Vue.prototype.$bus = new Vue();
